import { POST } from "../../index";

export const selectCarVideoPreviewList = (param) => POST("/v1/videoPreview/selectCarVideoPreviewList", param);
export const startLiveVideo = (param) => POST("/v1/videoPreview/startLiveVideo", param);
export const stopLiveVideo = (param) => POST("/v1/videoPreview/stopLiveVideo", param);
export const convertVideoFormat = (param) => POST("/v1/videoPreview/convertVideoFormat", param);

// 新的实时视频接口
export const getRealtimeVideo = (param) => POST("/api/forklift/api/video/preview/start", param);

// 查询历史视频播放列表
export const getPlayList = (param) => POST("/v1/videoPreview/getPlayList", param);
// 开始播放历史视频
export const startHistoryVideo = (param) => POST("/v1/videoPreview/startHistoryVideo", param);
// 停止播放历史视频
export const stopHistoryVideo = (param) => POST("/v1/videoPreview/stopHistoryVideo", param);
// 下载历史视频
export const downloadHistoryVideo = (param) => POST("/v1/videoPreview/downloadHistoryVideo", param);
